import { FormControl } from '@angular/forms';
import { Note, UserLite } from '@card-software/library';
import { AuditTrail } from '@card-software/nexus-models';
import { InventoryTransaction } from './inventory-transaction';
import { EntityKey, EntityKeyByNumber } from './keys/entity-key';

/**
 * LotItemTransfer Status enum matching backend
 */
export enum LotItemTransferStatus {
  Draft = 0,
  ReadyForTransfer = 1,
  InRoute = 2,
  Received = 3,
  Voided = 99,
}

/**
 * LotItemTransfer Type enum
 */
export enum LotItemTransferType {
  FinishedGoodsToRolling = 2,
  Relocation = 3,
  FinishedGoodsTransfer = 4,
  TransferToFinishedGoods = 5,
  ProductionToFinishedGoods = 6,
  RawMaterialToFinishedGoods = 7,
  ChemicalBatchToFinishedGoods = 8,
  FinishedGoodsToRawMaterial = 9,
  GreigeSample = 10,
  FinishedSample = 11,
}

export enum RelocationWarehouse {
  FinishedGoods = 'WH-FG-1',
  RawMaterial = 'WH-RM-1',
}

/**
 * Status history entry for tracking status changes
 */
export interface LotItemTransferStatusHistoryEntry {
  status: LotItemTransferStatus;
  date: Date;
  user?: UserLite;
}

/**
 * Note entry
 */
export interface LotItemTransferNote {
  content: string;
  createdAt: Date;
  createdBy?: {
    firstName?: string;
    lastName?: string;
    username?: string;
  };
}

/**
 * Main DTO returned from API
 */
export interface LotItemTransferDto extends AuditTrail {
  id: string;
  number: string;
  status: LotItemTransferStatus;
  transferType: LotItemTransferType;
  items: EntityKeyByNumber[];
  fromLocationCode: string;
  toLocationCode: string;
  fromLocationName?: string;
  toLocationName?: string;
  notes: Note[];
  statusHistory: LotItemTransferStatusHistoryEntry[];
  inventoryTransaction?: InventoryTransaction;
  initiator?: EntityKey;
}

/**
 * Insert command for creating new transfer
 */
export interface LotItemTransferInsertCommand {
  fromLocationCode: string;
  toLocationCode: string;
  transferType?: LotItemTransferType;
  initiator?: EntityKey;
  notes?: Note[];
}

/**
 * Search command for filtering transfers
 */
export interface LotItemTransferSearchCommand {
  searchTerm?: string;
  statuses?: LotItemTransferStatus[];
  transferTypes?: LotItemTransferType[];
  fromLocationCode?: string;
  toLocationCode?: string;
}

/**
 * Batch add items command
 */
export interface BatchAddLotItemKeyCommand {
  items: EntityKeyByNumber[];
}

/**
 * Status update command
 */
export interface LotItemTransferStatusCommand {
  newStatus: LotItemTransferStatus;
}

export interface AvailableLotItemDto {
  number: string;
  itemCode?: string;
  manufacturerReference?: string;
  manufacturerName?: string;
  manufacturerLotNumber?: string;
  providerReference?: string;
  providerName?: string;
  netQuantity: number;
}

/**
 * Form interface for search filters
 */
export interface LotItemTransferSearchForm {
  searchByNumber: FormControl<string | null>;
  status: FormControl<LotItemTransferStatus[] | null>;
}
